<template>
  <v-container>
    <label for="slider-duration" class="v-label theme--light">Treatment Duration (days)</label>
    <v-range-slider
      id="slider-duration"
      v-model="localFilter.duration" 
      :min="attributes.duration.min" 
      :max="attributes.duration.max"
      thumb-size="30" 
      color="purple" 
      class="control"
      thumb-label="always"	
    ></v-range-slider>
    <label for="slider-age" class="v-label theme--light">Age (years)</label>
    <v-range-slider
      dense
      id="slider-age"
      v-model="localFilter.age" 
      :min="attributes.age.min" 
      :max="attributes.age.max"
      thumb-size="24" 
      color="purple" 
      thumb-label="always"
      class="control"
    ></v-range-slider>
    <v-subheader class="pl-0">Diseases</v-subheader>
    <v-row v-for="disease in localFilter.diseases" :key="disease.name">
      <v-col cols=3 class="py-0">
        <span> {{disease.name}}</span>
      </v-col>
      <v-col cols=9 class="py-0">
        <v-radio-group v-model="disease.status" row style="padding: 0; margin: 0;" dense>
          <v-radio class="pa-0" label="both" value="both" color="purple dark-2" :off-icon="mdiCheckboxBlankCircleOutline" :on-icon="mdiCheckboxBlankCircle"></v-radio>
          <v-radio class="pa-0" :label="`yes`" value="yes" color="purple dark-2" :off-icon="mdiCheckboxBlankCircleOutline" :on-icon="mdiCheckboxBlankCircle"></v-radio>
          <v-radio class="pa-0" :label="`no`" value="no" color="purple dark-2" :off-icon="mdiCheckboxBlankCircleOutline" :on-icon="mdiCheckboxBlankCircle"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <div style="min-height:30px;"/>
    <div style="min-height:2px; background: black;"/>
    <div style="min-height:40px;"/>
    <label for="slider-depth" class="v-label theme--light">Number of events in the record</label>
    <v-slider
      dense
      id="slider-depth"
      v-model="localFilter.depth" 
      :min="attributes.depth.min" 
      :max="attributes.depth.max"
      :thumb-size="24" 
      color="purple" 
      thumb-label="always"
      class="control"
    ></v-slider>
    <label for="slider-prune_threshold" class="v-label theme--light">Minimum number of patient per sequence</label>
    <v-slider
      dense
      id="slider-prune_threshold"
      v-model="localFilter.prune_threshold" 
      :min="attributes.prune_threshold.min" 
      :max="attributes.prune_threshold.max"
      :thumb-size="36" 
      color="purple" 
      thumb-label="always"
      class="control"
    ></v-slider>
    <v-row>
      <v-text-field v-model.number="localFilter.aggregate_coarse_level" type="number" label="Aggregation Level" :min="attributes.aggregate_coarse_level.min" @input="updateAggregationLevel"/>
    </v-row>
    <v-row>
      <v-col cols=6 class="py-0">
        <label for="slider-nb_treatment_duration" class="v-label theme--light">No treatment duration</label>
        <v-slider
          id="slider-nb_treatment_duration"
          v-model="localFilter.no_treatment_duration" 
          :min="attributes.no_treatment_duration.min" 
          :max="attributes.no_treatment_duration.max" 
          :thumb-size="24" 
          color="purple" 
          thumb-label="always"
          class="control"
        ></v-slider>
      </v-col>
      <v-col cols=6 class="py-0">
        <label for="slider-interruption_duration" class="v-label theme--light">NInterruption duration</label>
        <v-slider
          id="slider-interruption_duration"
          v-model="localFilter.interruption_duration" 
          :min="attributes.interruption_duration.min" 
          :max="attributes.interruption_duration.max" 
          :thumb-size="24" 
          color="purple" 
          thumb-label="always"
          class="control"
        ></v-slider>
      </v-col>
    </v-row>
    <v-btn @click="update()" :color="localFilterChanged() ? 'warning': ''" :disabled="!localFilterChanged()" id="update-filter">Update</v-btn>
    &nbsp; &nbsp;
    <v-btn @click="reset()" id="reset-filter"> Reset </v-btn>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// eslint-disable-next-line
import _, { map } from 'underscore';
import { mdiCheckboxBlankCircle, mdiCheckboxBlankCircleOutline } from '@/svgIcons';

export default {
  data(){
    return {
      localFilter: {},
      oldFilter: {},
      mdiCheckboxBlankCircle: mdiCheckboxBlankCircle,
      mdiCheckboxBlankCircleOutline: mdiCheckboxBlankCircleOutline,
    }
  },
  components: {
  },
  mounted () {
    this.reset()
    this.oldFilter = this.copyFilter(this.localFilter);
  },
  watch: {
    filter: {
      handler(data) {
        this.localFilter = this.copyFilter(data);
        this.oldFilter   = this.copyFilter(data);
      },
      deep: true,
    }
  },
  computed: {
    ...mapGetters(['attributes', 'filter']),
  },
  methods: {
    ...mapActions(["update_node_tree"]),    
    reset() {
      this.oldFilter = this.copyFilter(this.filter);
      this.localFilter = {
        diseases: this.attributes.diseases.default.map(d => ({ name: d, status: 'both' })),
        duration: this.attributes.duration.default,
        age: this.attributes.age.default,
        no_treatment_duration: this.attributes.no_treatment_duration.default,
        interruption_duration: this.attributes.interruption_duration.default,
        depth:     this.attributes.depth.default,
        prune_threshold: this.attributes.prune_threshold.default,
        aggregate_coarse_level: this.attributes.aggregate_coarse_level.default,
        hidden_items: this.attributes.hidden_items.default,
      }
    },

    update() {
      this.update_node_tree({ filter: {...this.localFilter}, reset: this.shouldReset()});
      this.oldFilter = this.copyFilter(this.localFilter);
    },

    shouldReset() {
      //General idea: Do not consider "visualization" variables in the reset process.
      let f1 = {...this.localFilter};
      let f2 = {...this.oldFilter};
      f1.aggregate_coarse_level = f2.aggregate_coarse_level = undefined;
      f1.hidden_items           = f2.hidden_items           = undefined;
      f1.prune_threshold        = f2.prune_threshold        = undefined;
      f1.depth                  = f2.depth                  = undefined;
      return !_.isEqual(f1, f2);
    },

    copyFilter(localFilter) {
      let oldlocalFilter          = {...localFilter};
      //Make a deep copy of "diseases"...
      oldlocalFilter.diseases = [...localFilter.diseases];
      for(let i = 0; i < oldlocalFilter.diseases.length; i++)
        oldlocalFilter.diseases[i] = {...localFilter.diseases[i]};
      return oldlocalFilter;
    },

    localFilterChanged() {
      return !_.isEqual(this.oldFilter, this.localFilter);
    },

    updateAggregationLevel() {
      if(isNaN(this.localFilter.aggregate_coarse_level))
        return;
      let level = parseInt(this.localFilter.aggregate_coarse_level);
      if(isNaN(level))
        return;
      if(level < this.attributes.aggregate_coarse_level.min)
        this.localFilter.aggregate_coarse_level = this.attributes.aggregate_coarse_level.min;
    },
  }
};
</script>
<style>
.control {
  padding-top: 0em;
}
</style>
